// Feedback visual no bloqueante. Reemplaza alert()/confirm() en todo el pack móvil:
// un alert() detiene el hilo y exige un tap extra — en un flujo de bodega repetido
// decenas de veces por turno, eso es la mitad de la fricción.
export function toast(message, type = "success", ms = type === "error" ? 5000 : 2500) {
  const holder = document.getElementById("m-toasts")
  if (!holder || !message) return

  const el = document.createElement("div")
  el.className = `m-toast m-toast--${type}`
  el.textContent = message
  holder.appendChild(el)

  requestAnimationFrame(() => el.classList.add("is-in"))
  setTimeout(() => {
    el.classList.remove("is-in")
    setTimeout(() => el.remove(), 300)
  }, ms)
}

// Lee el flash del servidor (renderizado como data-attributes en #m-flash,
// invisible) y lo muestra como toasts. Así el layout móvil no necesita el
// patrón toastr+<script> del layout de escritorio.
export function showFlashToasts() {
  const flash = document.getElementById("m-flash")
  if (!flash) return

  Object.entries(flash.dataset).forEach(([type, message]) => toast(message, type))
}
